import { Component, type ReactElement } from "react";
import { connect } from "react-redux";

import { type IPlaybookPage } from "../../../app-utils/playbook.js";
import { clearInitialJob } from "../../../redux/modules/job.js";
import { clearFormData } from "../../../redux/modules/playbook-admin.js";
import { type IAppState } from "../../../redux/reducer.js";
import { ModulesIcons } from "../../../settings/assets-settings.js";
import PlaybookWizard from "../PlaybookWizard.js";
import { BlastInputForm } from "./BlastInputForm.js";

interface IBlastWizardOwnProps {
  onClose: () => void;
}

interface IBlastWizardAppStateProps {
  documentationUrl: string;
}

interface IBlastWizardDispatchProps {
  clearFormData: () => void;
  clearInitialJobData: () => void;
}

export interface IBlastWizardProps extends IBlastWizardAppStateProps, IBlastWizardDispatchProps, IBlastWizardOwnProps {}

function mapStateToProps(state: IAppState, _ownProps: IBlastWizardProps): IBlastWizardAppStateProps {
  return {
    documentationUrl: state.config.configuration?.application?.documentationUrl,
  };
}

function mapDispatchToProps(dispatch): IBlastWizardDispatchProps {
  return {
    clearFormData: () => dispatch(clearFormData()),
    clearInitialJobData: () => dispatch(clearInitialJob()),
  };
}

export const BLAST_WIZARD_SCREEN_IDS = {
  BLAST_INPUT_SCREEN: "blastInputScreen",
};

class BlastWizardImpl extends Component<IBlastWizardProps> {
  static views: IPlaybookPage[] = [
    {
      pageIdentifier: BLAST_WIZARD_SCREEN_IDS.BLAST_INPUT_SCREEN,
      title: "Define Your BLAST Parameters",
      label: "BLAST Input",
    },
  ];

  constructor(props: IBlastWizardProps) {
    super(props);
  }

  onClose = () => {
    this.props.clearFormData();
    this.props.clearInitialJobData();
    this.props.onClose();
  };

  render(): ReactElement {
    return (
      <PlaybookWizard
        playbook
        title={"BLAST"}
        steps={BlastWizardImpl.views}
        mapStepToScreen={this.mapStepToScreen}
        onClose={this.onClose}
        icon={ModulesIcons.BLAST}
        helpLink={`${this.props.documentationUrl}BLAST%2bSearch%2bPlaybook`}
      />
    );
  }

  mapStepToScreen = (page: IPlaybookPage) => {
    if (page.pageIdentifier === BLAST_WIZARD_SCREEN_IDS.BLAST_INPUT_SCREEN) {
      return <BlastInputForm playbookPage={page} />;
    }
  };
}

const BlastWizard = connect<IBlastWizardAppStateProps, IBlastWizardDispatchProps, IBlastWizardOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(BlastWizardImpl);

export { BlastWizard };
export default BlastWizard;
